import { CollectionName } from "@super-real/types";
import { collection } from "firebase/firestore";
import { db } from "../consts/FIREBASE";

export function getCollectionRef(collectionName: CollectionName) {
  return collection(db, collectionName);
}
